import { configureStore } from '@reduxjs/toolkit'
import userReducer from 'src/redux/User/UserSlice'
import userIAMReducer from 'src/redux/IAM/AdminUser/UserIAMSlice'
import permissionsReducer from 'src/redux/IAM/AdminPermission/permissionSlice'
import groupsReducer from 'src/redux/IAM/AdminGroups/adminGroupsSlice'
import endpointsReducer from 'src/redux/IAM/AdminEndpoints/adminEndpointsSlice'
import appsReducer from 'src/redux/IAM/AdminApps/adminAppsSlice'
import kpiFormReducer from 'src/redux/Dashboard/KPIForm/KPIFormSlice'
import kpiChartReducer from 'src/redux/Dashboard/Charts/ChartsSlice'
import LoadingSlice from './Components/Loading/LoadingSlice'
import PaginationSlice from './Components/Pagination/PaginationSlice'
import adminModulesSlice from './IAM/AdminModules/adminModulesSlice'
import strategySlice from './Dashboard/Strategies/StrategiesSlice'
import IndicatorsSlice from './Dashboard/Indicators/IndicatorsSlice'
import QuestionsSlice from './Dashboard/Questions/QuestionsSlice'
import webScoketSlice from './Websocket/webScoketSlice'
import webSocketMiddleware from './Websocket/webScoketMiddleware'
import kpUserSlice from './Onboarding/user/kpUserSlice'
import testModelsSlice from './Onboarding/testModels/testModelsSlice'
import AlertSlice from './Components/Alert/AlertSlice'

/**
 * The Redux store is created using `configureStore`, which includes the application's reducers
 * and middleware.
 *
 * @constant
 * @type {Store}
 */
const store = configureStore({
  reducer: {
    alert: AlertSlice,
    user: userReducer,
    userIAM: userIAMReducer,
    groups: groupsReducer,
    permissions: permissionsReducer,
    endpoints: endpointsReducer,
    apps: appsReducer,
    kpiForm: kpiFormReducer,
    kpiChart: kpiChartReducer,
    modules: adminModulesSlice,
    loading: LoadingSlice,
    pagination: PaginationSlice,
    strategy: strategySlice,
    indicators: IndicatorsSlice,
    questions: QuestionsSlice,
    webSocket: webScoketSlice,
    kpUser: kpUserSlice,
    testModel: testModelsSlice,
  },
  /**
   * Adds middleware to the Redux store, including default middleware and custom WebSocket middleware.
   *
   * @param {MiddlewareArray} getDefaultMiddleware - The default middleware provided by Redux Toolkit.
   * @returns {MiddlewareArray} - The enhanced middleware array with WebSocket middleware included.
   */
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(webSocketMiddleware),
})

/**
 * Type representing the root state of the Redux store.
 *
 * This type is inferred from the store's `getState` method and can be used for type-safe
 * access to the state in components or other parts of the app.
 *
 * @typedef {ReturnType<typeof store.getState>} RootState
 */
export type RootState = ReturnType<typeof store.getState>

/**
 * Type representing the dispatch method from the Redux store.
 *
 * This type can be used to ensure type safety when dispatching actions to the store.
 *
 * @typedef {typeof store.dispatch} AppDispatch
 */
export type AppDispatch = typeof store.dispatch

/**
 * The default export is the configured Redux store, which includes all the reducers
 * and middleware required for the application.
 *
 * @default
 */
export default store
